import React from 'react'
import Logo from './logo/ketaqwaan-logo.png'

function NotFound() {
  return (
    <div className="min-h-screen w-full relative bg-gradient-to-br from-teal-600 via-teal-700 to-teal-900 text-white flex items-center justify-center overflow-hidden px-4 lg:pt-20 lg:pb-8 pt-4 pb-0">
      
      {/* Background Circles */}
      {/* <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-20 w-32 h-32 border-2 border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-32 w-24 h-24 border-2 border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 left-40 w-40 h-40 border-2 border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-28 h-28 border-2 border-white/20 rounded-full"></div>
      </div> */}

      {/* Main Container */}
      <div className="relative z-10 max-w-xl text-center space-y-8">
        
        {/* Ornament */}
        {/* <div className="mx-auto w-24 h-24 mt-4 flex items-center justify-center rounded-full bg-white/10 border border-white/20 backdrop-blur">
          <img src={Logo} alt="Logo" className="w-20" />
        </div> */}

        {/* Error Number */}
        <h1 className="lg:text-8xl text-5xl font-bold text-white/90">404</h1>

        {/* Decorative Line */}
        <div className="w-32 h-1 mx-auto bg-gradient-to-r from-transparent via-white/60 to-transparent rounded-full"></div>

        {/* Main Message */}
        <div className="space-y-2">
          <h2 className="lg:text-2xl text-lg font-semibold">Halaman Tidak Ditemukan</h2>
          <p className="text-white/80 lg:text-lg text-sm">Maaf, halaman yang Anda cari tidak dapat ditemukan.</p>
          <p className="text-white/70 lg:text-base text-xs">Mungkin halaman telah dipindahkan atau URL yang dimasukkan salah.</p>
        </div>

        {/* Islamic Quote */}
        <div className="bg-white/10 border border-white/20 p-6 rounded-xl backdrop-blur space-y-2">
          <p className="italic text-white/90 lg:text-lg text-sm leading-relaxed">
            "Dan barangsiapa yang bertakwa kepada Allah niscaya Dia akan mengadakan baginya jalan keluar."
          </p>
          <p className="lg:text-sm text-xs text-white/70">- QS. At-Talaq: 2</p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => window.history.back()}
            className="bg-white text-teal-800 lg:text-base text-sm font-semibold py-2 px-6 rounded-xl shadow-md hover:bg-white/90 transition transform hover:scale-105"
          >
            ← Kembali
          </button>
          <a
            href="/"
            className="bg-white/20 border border-white/30 text-white lg:text-base text-sm font-semibold py-2 px-6 rounded-xl backdrop-blur hover:bg-white/30 transition transform hover:scale-105"
          >
            🏠 Beranda
          </a>
        </div>

        {/* Help Section */}
        {/* <div className="bg-white/5 border border-white/10 p-4 rounded-lg backdrop-blur">
          <h3 className="text-white font-semibold text-lg leading-relaxed">
            Terima Kasih <br />😇 <br />—Admin
          </h3>
        </div> */}

        {/* Decorative Dots */}
        <div className="flex justify-center gap-6">
          <div className="w-2 h-2 rounded-full bg-white/40 animate-pulse"></div>
          <div className="w-2 h-2 rounded-full bg-white/40 animate-pulse delay-200"></div>
          <div className="w-2 h-2 rounded-full bg-white/40 animate-pulse delay-400"></div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-teal-900/70 to-transparent pointer-events-none" />
    </div>
  )
}

export default NotFound
